import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Apollo } from 'apollo-angular';
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { NotificationService } from '../../../../services/notification.service';
import { ResponseCodeService } from '../../../../services/response-code.service';
import * as fromActions from './institution-services-summary.actions';
import { map, switchMap } from 'rxjs/operators';
import * as fromGraphql from './institution-services-summary.graphql';
import {GET_POPSM_INSTITUTIONS_SERVICES_SUMMARY_STATS} from "./institution-services-summary.graphql";

@Injectable()
export class InstitutionServicesSummaryEffects {
  getInstitutionsServicesSummary$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.getInstitutionsServicesSummary),
        switchMap((action) => {
          return this.apollo
            .query({
              query: action?.isStats ? fromGraphql.GET_POPSM_INSTITUTIONS_SERVICES_SUMMARY_STATS: fromGraphql.GET_POPSM_INSTITUTIONS_SERVICES_SUMMARY,
              variables: {
                filtering:action?.filtering
              },
              fetchPolicy: 'network-only',
            })
            .pipe(
              this.notificationService.catchError(
                'Problem occurred while fetching Institutions Services Summary'
              ),
              map(({ data }: any) => {
                if (data) {
                  const result: any = Object.values(data)[0];
                  this.store.dispatch(
                    fromActions.clearInstitutionsServicesSummary())
                  result?.response?.status
                    ? this.store.dispatch(
                        fromActions.upsertInstitutionsServicesSummary({
                          institutionsServicesSummary:
                            result?.data?.allInstitutions,
                          sumTotalServices: result?.data?.sumTotalServices,
                          sumApprServices: result?.data?.sumApprServices,
                          sumDraftServices: result?.data?.sumDraftServices,
                          sumRejectedServices:
                            result?.data?.sumRejectedServices,
                          totalInst: result?.data?.totalInst
                        })
                      )
                    : [];
                }
              })
            );
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
